import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import ChartWrap from './ChartWrap';

Highcharts.setOptions({ lang: { thousandsSep: ',' } });

const HighchartGraph = (props) => {
  const {
    options,
    loading,
    helperText = { align: 'right', text: null },
  } = props;

  return (
    <>
      <ChartWrap status={loading}>
        <HighchartsReact highcharts={Highcharts} options={options} />
        {!!helperText['text'] && (
          <p style={{ margin: 0, fontSize: 10, textAlign: helperText.align }}>
            {helperText.text}
          </p>
        )}
      </ChartWrap>
    </>
  );
};

export default HighchartGraph;
